/** The page's initial loading element, held while the app runs so it can cover the page again on logout. */
export class RHDetachedLoadingView {

    private static _element?: HTMLElement

    static hold(element: HTMLElement) {
        RHDetachedLoadingView._element = element
    }

    static heldElement(): HTMLElement | undefined {
        return RHDetachedLoadingView._element
    }

}
